import Axios from "axios";
import { CMError } from "./cm-error.model";
import Vue from 'vue'
Vue.mixin({
    beforeCreate() {
        const options = this.$options;
        if (options.CommunityAPI)
            this.$communityApi = options.CommunityAPI;
        else if (options.parent && options.parent.$communityApi)
            this.$communityApi = options.parent.$communityApi;
    }
});

export function makeCommunityAPI(token, conf) {
    return new CommunityAPI(token, conf);
}

export class CommunityAPI {
    constructor(token, conf) {
        this.__ax = null;
        this._conf = conf;
        this._token = token;
    }

    get _ax() {
        if (this.__ax === null) {
            this.__ax = Axios.create({
                baseURL: this._conf.getters.conf.profile_url + "/api",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + this._token,
                }
            });
        }
        return this.__ax;
    }

    async getCommunities(page, perPage, view) {
        try {
            const res = await this._ax.get(
                "me/communities" + (view ? "/" + view : "") + "?page=" + page + "&per_page=" + perPage + "&full=1"
            );
            return res.data.data;
        } catch (error) {
            return this._handleError(error);
        }
    }

    async getCommunity(id) {
        try {
            const res = await this._ax.get(
                "me/communities/" +
                id +
                "/asLeader?p=leaders,basedIn,logo,cover,description,membersCount,topics,socials,status,slug"
            );
            return this.formatCommunity(res.data.data);
        } catch (error) {
            return this._handleError(error);
        }
    }

    async getCommunityEmpty() {
        try {
            const res = await this._ax.get("/communities/empty");
            return this.formatCommunity(res.data.data);
        } catch (error) {
            return this._handleError(error);
        }
    }

    async getUsers(input) {
        try {
            const res = await this._ax.get(
                "/profiles/search/" + encodeURIComponent(input)
            );
            return res.data.data;
        } catch (error) {
            this._handleError(error);
        }
    }

    async addCommunity(community, logo, cover) {
        let sCommunity = Object.assign({}, community);
        delete sCommunity.social;
        delete sCommunity.logo;
        delete sCommunity.cover;
        Object.keys(community.social).forEach(s => {
            const ind = sCommunity.socials.findIndex(f => f.name.toLowerCase() === s);
            if (ind !== -1) {
                sCommunity.socials[ind].link = community.social[s];
            }
        });
        // sCommunity.leaders = community.leaders.map(l => l.uid);
        try {
            const res = await this._ax.post("/communities/asLeader", sCommunity);
            const cid = res.data.data;
            if (logo) {
                const dataLogo = new FormData();
                dataLogo.append("logo", logo);
                this._ax
                    .put("/communities/" + cid + "/asLeader/logo", dataLogo, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    })
                    .then(res => {
                        community.logo = res.data.data;
                    });
            }

            if (cover) {
                const dataCover = new FormData();
                dataCover.append("cover", cover);
                this._ax
                    .put("/communities/" + cid + "/asLeader/cover", dataCover, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    })
                    .then(res => {
                        community.cover = res.data.data;
                    });
            }
            return cid;
        } catch (error) {
            this._handleError(error);
        }
    }

    /**
     *
     * @param {string} cid
     * @param {import("codemotion").CMCommunity} community
     */
    async updateCommunity(cid, community, logo, cover) {
        let sCommunity = Object.assign({}, community);
        delete sCommunity.social;
        delete sCommunity.logo;
        delete sCommunity.cover;
        Object.keys(community.social).forEach(s => {
            const ind = sCommunity.socials.findIndex(f => f.name.toLowerCase() === s);
            if (ind !== -1) {
                sCommunity.socials[ind].link = community.social[s];
            }
        });
        // sCommunity.leaders = community.leaders.map(l => l.uid);
        try {
            const res = await this._ax.put("/communities/" + cid + "/asLeader", sCommunity);

            if (logo) {
                const dataLogo = new FormData();
                dataLogo.append("logo", logo);
                this._ax
                    .put("/communities/" + cid + "/asLeader/logo", dataLogo, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    })
                    .then(res => {
                        community.logo = res.data.data;
                    });
            }

            if (cover) {
                const dataCover = new FormData();
                dataCover.append("cover", cover);
                this._ax
                    .put("/communities/" + cid + "/asLeader/cover", dataCover, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    })
                    .then(res => {
                        community.cover = res.data.data;
                    });
            }

            return res.data.data;
        } catch (error) {
            this._handleError(error);
        }
    }

    async getCommunityStats(cid, year) {
        try {
            const res = await this._ax.get(`/communities/${cid}/stats/${year}`);
            return res.data.data;
        } catch (error) {
            return this._handleError(error);
        }
    }

    /**
     *
     * @param {import("codemotion").CMCommunity} community
     */
    formatCommunity(community) {
        community.social = community.socials.reduce((newS, item) => {
            newS[item.name.toLowerCase()] = item.link;
            return newS;
        }, {});
        if (!community.description) community.description = "";
        if (!community.name) community.name = "";
        return community;
    }

    _handleError(error) {
        if (error.response) {
            if (error.response.status === 401) {
                console.error(error.response.data.errors[0].message);
                throw new CMError(
                    "UnauthorizedRedirect",
                    error.response.data.errors[0].message
                );
            }
            if (this._checkTokenDelete(error.response.data.errors)) {
                console.error("Invalid or expired token");
                throw new CMError("Unauthorized", "Invalid or expired token");
            }
            const errMess = error.response.data.errors.reduce((errT, err) => {
                return (errT += `[${err.name}] => ${err.message};`);
            }, "");
            console.error(errMess);
            throw new CMError("CMServerErrorList", errMess);
        } else if (error.request) {
            console.error("Error on request => Server does not respond");
            throw new Error("Error on request => Server does not respond");
        } else {
            console.error("Client error => " + error.message);
            throw new Error("Client error => " + error.message);
        }
    }

    _checkTokenDelete(errors) {
        if (!errors) {
            return false;
        }
        const tError = errors.findIndex(elem => {
            return (
                elem.name === "CMInvalidTokenError" ||
                elem.name === "CMInvalidExpiredError"
            );
        });
        return tError !== -1;
    }
}
